export default __webpack_public_path__ + "static/media/quotation-marks.90225acf.svg";